// ignore-string-externalization
import styled, { css } from 'styled-components';
import { screenSmMin, screenXsMin, spacer16, spacer24, spacer32, spacer40, spacer48, spacer8, Type } from '@spotify-internal/encore-web';
export var ContentTitle = styled(Type.h2).attrs({
  variant: Type.heading2,
  weight: Type.bold
}).withConfig({
  displayName: "common__ContentTitle",
  componentId: "sc-1iz3gfl-0"
})(["margin-top:", ";padding-bottom:", ";"], spacer8, spacer40);
export var contentPadding = css(["flex:2;padding:", ";@media (max-width:", "){padding:", " ", ";}@media (max-width:", "){padding:", " ", ";}"], spacer48, screenSmMin, spacer32, spacer24, screenXsMin, spacer24, spacer16);
export var ContentBody = styled.div.withConfig({
  displayName: "common__ContentBody",
  componentId: "sc-1iz3gfl-1"
})(["max-width:720px;flex:2;", ""], contentPadding);